/**
 * Hook to get configured terminology
 */

import { useState, useEffect, useCallback } from 'react';

interface Terminology {
  workItemName: string;
  workItemNamePlural: string;
  workPackageName: string;
  workPackageNamePlural: string;
}

const DEFAULT_TERMINOLOGY: Terminology = {
  workItemName: 'Work Item',
  workItemNamePlural: 'Work Items',
  workPackageName: 'Work Package',
  workPackageNamePlural: 'Work Packages',
};

interface UseTerminologyReturn extends Terminology {
  t: (key: keyof Terminology, fallback?: string) => string;
}

export function useTerminology(): UseTerminologyReturn {
  const [terminology, setTerminology] = useState<Terminology>(DEFAULT_TERMINOLOGY);

  useEffect(() => {
    const stored = localStorage.getItem('terminology');
    if (stored) {
      try {
        const parsed = JSON.parse(stored);
        setTerminology({ ...DEFAULT_TERMINOLOGY, ...parsed });
      } catch {
        setTerminology(DEFAULT_TERMINOLOGY);
      }
    }
  }, []);

  const t = useCallback(
    (key: keyof Terminology, fallback?: string): string => {
      return terminology[key] || fallback || DEFAULT_TERMINOLOGY[key];
    },
    [terminology]
  );

  return {
    ...terminology,
    t,
  };
}
